import SeoHead from '../../components/SeoHead';
import { Global } from "@sourceflow-uk/sourceflow-sdk"
import React from 'react';
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import Link from 'next/link';
import SubBanner from '../../components/SubBanner';
import SimplePage from '../../components/SimplePage';
import Header from '../../components/MainHeader';
import MailchimpWidget from '../../components/MailchimpWidget';

export default function RecruitStaff({
    global
}) {
    return (
        <>
            <SeoHead
                // site_name={`Driving Force`}
                page_name={`Recruit Staff | Gap Personnel`}
                // description={``}
                canonical_link={`/recruit-staff/`}
            />
            <Header />
            <SubBanner
                global={global}
                pathPrefix={`recruit_staff_page.sub_banner`}
                customClass={`mb-5 primary-banner`}
                buttonTitle={`Employers`}
                buttonLink={`/who-we-are/`}
                heading={`Recruit staff`}
                bannerImage="/site-assets/images/recruit-staff.jpg"
                bannerImageAlt="Recruit Staff"

            />
            <SimplePage
                global={global}
                pathPrefix={`recruit_staff_page.simple_page`}
                customClass={``}
                content={
                    <>
                        <p>No matter what your driving needs may be, we've got you covered. Our team comprises of highly skilled professionals, driven by innovation and backed by over 100+ years of collective expertise in the industry. Whether you're seeking experienced drivers or seeking employment opportunities, we are here to provide dedicated assistance and support.</p>
                    </>
                }
                formId={`56e6149f-9986-4f65-a7fa-b99c818e52b3`}
                textCenter={true}
            />
            <MailchimpWidget />
        </>
    );
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();

    return {
        props: {
            global
        },
    }
}